import React, { useEffect, useState, Fragment } from "react";
import { GetRout, PostRoute } from "../../Services/Private";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Container,
  ProgressBar,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useForm } from "react-hook-form";
import Bodega from "../../Base/assets/1.png";
import Espera from "../../Base/assets/2.png";
import Transito from "../../Base/assets/3.png";
import Combex from "../../Base/assets/4.png";
import Aduana from "../../Base/assets/5.png";
import Liberado from "../../Base/assets/6.png";
import BodegaGT from "../../Base/assets/7.png";
import Entrega from "../../Base/assets/8.png";
import Retorno from "../../Base/assets/9.png";
import Entregado from "../../Base/assets/10.png";
import Log from "../../Base/assets/logo11.png";
import Send from "../../Base/assets/envio.gif"
import { CardFooter, CardTitle } from "reactstrap";

const Seguidor = () => {
  const [datosPedido, setDatosPedido] = useState([]),
        [validate, setValidate] = useState(false),
    { register, handleSubmit, setvalue } = useForm(),
    onSubmit = (data,e) => {
      const json = {
        id: data.id,
        estado : e.target.estado.value
      };

      
    obtenerPedido(json);
    },
    obtenerPedido = async (data) => {

     
        if(data.estado == 1){
         
           const response = await PostRoute(`pedidos/track3`, data);
            setDatosPedido(response.length ? response : [0]);
            {response.length  ? setValidate(true) : setValidate(false)}
        }
        if(data.estado == 2){
        
          const response = await PostRoute(`pedidos/track1`, data);
            setDatosPedido(response.length ? response : [0]);
            {response.length  ? setValidate(true) : setValidate(false)}

       }
       if(data.estado == 3){
       const response = await PostRoute(`pedidos/track2`, data);
            setDatosPedido(response.length ? response : [0]);
            {response.length  ? setValidate(true) : setValidate(false)}
     }
         
    },
    reset = () => {
      setDatosPedido(null);
      window.location.reload();
    };

  useEffect(() => {}, [datosPedido]);

  return (
    <>
    <div className="containerseguidor">
      <Container>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <br />
              <img src={Log} width="350px" height="180px" className="img-fluid" alt="Responsive image"/>
            </Col>
          </Row>
          <Row>
            <Col>
              <br />
              <h1>Bienvenido Al Seguidor de Paquetes</h1>
            </Col>
          </Row>
          <Row>
            <Col sm={4} md={4} lg={4} xl={4}>
              <br />
              <Form.Control
                name="id"
                placeholder="Ingrese los datos del pedido"
                {...register("id", { required: true })}
              />
            </Col>
          </Row>
          <br/>
          <Row>
            <Col sm={4} md={4} lg={4} xl={4}>
            <Form.Label> <h5>Selecciona el tipo de busqueda</h5></Form.Label>
            </Col>
            
          </Row>
          
          <Row>
            
           
          <Col sm={4} md={4} lg={4} xl={4}>
            
          <Form.Check
              label="Codigo"
              name="estado"
              inline
              type="radio"
              value={1}
            ></Form.Check>
            <Form.Check
              label="Traking"
              name="estado"
              inline
              type="radio"
              value={2}
            ></Form.Check>
            <Form.Check
              label="Warehouse"
              name="estado"
              inline
              type="radio"
              value={3}
            ></Form.Check>
            
          </Col>
          </Row>
          <Row>
            <Col sm={4} md={4} lg={4} xl={4}>
              <Button variant="success" className="my-4" type="submit">
                Buscar
              </Button>
            </Col>
          </Row>
        </Form>

        <Row>
          {validate && (
            <Col>
              <Row>
                <Col>
                  <h2>Nombre Del Cliente: {datosPedido[0].nombreCliente}</h2>
                </Col>
                <Col>
                  <h2>No. Codigo Pedido: {datosPedido[0].codigo_pedido}</h2>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
        <br />
        <Row>
          { validate ?

            datosPedido.map((datosPedido, index) => {
              return (
                <Col sm={4}>
                  <Card className="cardSeguidor">
                    <CardTitle>
                      <h5 className="text-center my-2">
                        Paquete No: {index + 1}
                      </h5>
                    </CardTitle>
                    <Card.Body>
                      <h6>
                        No.Warehouse: <i>{datosPedido.warehouse}</i>
                      </h6>
                      <h6>
                        No.Tracking: <i>{datosPedido.tracking}</i>
                      </h6>
                      <h6>
                        shpName: <i>{datosPedido.shpName}</i>
                      </h6>
                      <h6>
                        totWtLbs: <i>{datosPedido.totWtLbs}</i>
                      </h6>
                      <h6>
                        totpcs: <i>{datosPedido.totpcs}</i>
                      </h6>
                      <h6>
                        descripcion: <p>{datosPedido.descripcion}</p>
                      </h6>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })
            : 
            <h1>No Se encontraron datos</h1>

          }
        </Row>
        <br />

        <Row>
          {validate  && (
            <Col>
              {datosPedido[0].estado === 1 && (
                <Row>
                  <Col>
                    <img src={Bodega} width="200px" height="200px" />
                    <h4 className="text-center">En Bodega MIAMI</h4>
                    <br />
                    <ProgressBar animated now={1} />
                  </Col>
                </Row>
              )}

              {datosPedido[0].estado === 2 && (
                <Row>
                  <Col>
                    <img src={Espera} width="200px" height="200px" />
                    <h4 className="text-center">En espera de Recoleccion Miami-Gt</h4>
                    <br />
                    <ProgressBar animated now={10} />
                  </Col>
                </Row>
              )}

              {datosPedido[0].estado === 3 && (
                <Row>
                  <Col>
                    <img src={Transito} width="200px" height="200px" />
                    <h4 className="text-center">En Transito Miami-Gt</h4>
                    <br />
                    <ProgressBar animated now={20} />
                  </Col>
                </Row>
              )}

              {datosPedido[0].estado === 4 && (
                <Row>
                  <Col>
                    <img src={Combex} width="200px" height="200px" />
                    <h4 className="text-center">Ingreso a COMBEX GT</h4>
                    <br />
                    <ProgressBar animated now={30} />
                  </Col>
                </Row>
              )}

              {datosPedido[0].estado === 5 && (
                <Row>
                  <Col>
                    <img src={Aduana} width="200px" height="200px" />
                    <h4 className="text-center">Proceso Aduanal</h4>
                    <br />
                    <ProgressBar animated now={40} />
                  </Col>
                </Row>
              )}
              {datosPedido[0].estado === 6 && (
                <Row>
                  <Col>
                    <img src={Liberado} width="200px" height="200px" />
                    <h4 className="text-center">Liberado Para Entrega</h4>
                    <br />
                    <ProgressBar animated now={60} />
                  </Col>
                </Row>
              )}
              {datosPedido[0].estado === 7 && (
                <Row>
                  <Col>
                    <img src={BodegaGT} width="200px" height="200px" />
                    <h4 className="text-center">Ingreso a Bodega GT</h4>
                    <br />
                    <ProgressBar animated now={70} />
                  </Col>
                </Row>
              )}
              {datosPedido[0].estado === 8 && (
                <Row>
                  <Col>
                    <img src={Entrega} width="200px" height="200px" />
                    <h4 className="text-center">En Ruta De Entrega</h4>
                    <br />
                    <ProgressBar animated now={80} />
                  </Col>
                </Row>
              )}
              {datosPedido[0].estado === 9 && (
                <Row>
                  <Col>
                    <img src={Retorno} width="200px" height="200px" />
                    <h4 className="text-center">Retorno a Bodega</h4>
                    <br />
                    <ProgressBar variant="danger" animated now={100} />
                  </Col>
                </Row>
              )}
              {datosPedido[0].estado === 10 && (
                <Row>
                  <Col>
                    <img src={Entregado} width="200px" height="200px" />
                    <h4 className="text-center">Entregado</h4>
                    <br />
                    <ProgressBar variant="success" animated now={100} />
                  </Col>
                </Row>
              )}
            </Col>
          )}
        </Row>
      
      </Container>
      
    </div>
    <div className="containerseguidor2">
       <CardFooter className="top">
    <Row>
      <Col>
        <h6>Derechos Reservados ON TIME COURIER</h6>
      </Col>
    </Row>
  </CardFooter>
    </div>
   
  </>
  );
};

export default Seguidor;
